// getInputDialog.js
import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

const keys2 = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "q", "w", "e", "r", "t", "y", "u", "i", "o", "p",
    "a", "s", "d", "f", "g", "h", "j", "k", "l", "z", "x", "c", "v", "b", "n", "m"];

export const GetInputDialog = ({ open, title, message, defaultValue = "", pattern, onClose, type, keys = keys2 }) => {
    const [value, setValue] = useState(defaultValue);

    const handleOk = () => {
        if (!pattern.test(value)) return;
        onClose(value);
    };

    const handleCancel = () => onClose(null);

    return (
        <Dialog open={open} onClose={handleCancel}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <p>{message}</p>
                <TextField type={type} value={value} onChange={(e) => setValue(e.target.value)} autoFocus style={{ marginBottom: 20 }} />
                <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 5 }}>
                    {keys.map((k) => (
                        <Button key={k} onClick={() => setValue((v) => v + k)} variant="outlined">{k}</Button>
                    ))}
                    <Button onClick={() => setValue((v) => v.slice(0, -1))} variant="contained" color="secondary">⌫</Button>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel} color="inherit">Cancel</Button>
                <Button onClick={handleOk} color="primary">OK</Button>
            </DialogActions>
        </Dialog>
    );
};
